export enum FinishHandle {
  SR = "sr" as any,
  MS = "ms" as any,
  SM = "sm" as any,
  WG = "wg" as any,
  HW = "hw" as any,
  BK = "bk" as any,
  WH = "wh" as any,
  BZ = "bz" as any,
  CB = "cb" as any,
  SS = "ss" as any,
  GS = "gs" as any,
  ASH = "ash" as any,
  MSA = "msa" as any,
  GBK = "gbk" as any,
  CH = "ch" as any
}

export enum FinishDisplayName {
  SR = "Platinum",
  MS = "Brushed Silver",
  SM = "Silver Mist",
  WG = "Golden Oak",
  HW = "Heather Willow",
  BK = "Onyx",
  WH = "Alpine White",
  BZ = "Desert Bronze",
  CB = "Carbon",
  SS = "Stainless Steel",
  GS = "Galvanized Steel",
  ASH = "Ash Wood",
  MSA = "Matte Silver Anodized",
  GBK = "Gloss Black",
  CH = "Chrome"
}

export interface Finish {
  handle: FinishHandle;
  display_name: FinishDisplayName;
}
